import { useNavigate } from 'react-router-dom';
import s from './update-promo-modal.module.css';
import { Button } from '../../../../../../components/button/button';
import { ModalProps, Modal } from '../../../../../../components/modal/modal';
import { concatPath, buildParams } from '../../../../../../helpers/path';
import { useLang } from '../../../../../../hooks/use-lang';
import { useQueryParams } from '../../../../../../hooks/use-query-params';
import { RootPath, ManagerPath, PromotionPath } from '../../../../../../routes/manager/manager-enums';

export const UpdatePromoModal = (props: ModalProps) => {
  const { t } = useLang();
  const params = useQueryParams().getQueryParams();
  const navigate = useNavigate();

  const handleUpdate = () => {
    navigate(
      concatPath([RootPath.Manager, ManagerPath.Promotion, PromotionPath.Edit]) +
        buildParams({ id: params?.promoId, prolong: true }),
    );
  };

  return (
    <Modal {...props} title={t('Возобновить акцию')} className={s.feature}>
      <label>
        {t('Вы действительно хотите возобновить акцию {{promotion}}?', {
          promotion: params.promoName,
        })}
      </label>
      <div className={s.controls}>
        <Button variant="secondary" onClick={props.onClose}>
          {t('Отменить')}
        </Button>
        <Button variant="info" onClick={handleUpdate}>
          {t('Возобновить')}
        </Button>
      </div>
    </Modal>
  );
};
